module.exports = __webpack_public_path__ + "img/pengumuman-dark.b0fa71fb.svg";